var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"general-checkbox__wrapper"},[_c('q-checkbox',{attrs:{"label":_vm.label,"value":_vm.value,"disable":_vm.disable},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }